"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.If = void 0;
var _react = _interopRequireWildcard(require("react"));
// ideally we would use https://www.npmjs.com/package/tsx-control-statements

var If = function If(_ref) {
  var children = _ref.children,
    condition = _ref.condition;
  if (condition) {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, children);
  }
  return null;
};
exports.If = If;